import { render } from "./VendorsWithdrawalsCreateForm.vue?vue&type=template&id=ee98dc46"
import script from "./VendorsWithdrawalsCreateForm.vue?vue&type=script&lang=js"
export * from "./VendorsWithdrawalsCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__